<template>
  <div
    v-if="videos.length"
    class="flex-1 block sm:grid sm:grid-cols-2 lg:grid-cols-3 col-gap-3 row-gap-5"
  >
    <VideoCard
      v-for="(video, index) in videos"
      :key="`video-card-${index}`"
      :video="video"
      @edit="id => $emit('edit', id)"
      @delete="id => $emit('delete', id)"
    />
  </div>
  <div
    v-else
    class="flex items-center justify-center w-full h-full text-lg border rounded border-ricoma-gray-300"
  >
    <span>There are not videos for</span>
    <span class="ml-1 font-bold">{{ serie.name }}</span>
  </div>
</template>

<script>
import VideoCard from './VideoCard';

export default {
  name: 'VideoCards',
  components: { VideoCard },
  props: {
    videos: {
      type: Array,
      required: true,
    },
    serie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
};
</script>
